/**
 * Created by enixjin on 4/13/17.
 */


export class wechatJSONMessage {
}